import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Envelope, ChatCircle, Question, ArrowRight } from '@phosphor-icons/react';

const HelpSupportModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const supportEmail = 'support@paygbot.com';
  
  const handleEmailClick = () => {
    window.location.href = `mailto:${supportEmail}?subject=PayGBot Support Request`;
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="paygbot-modal-shell bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-md"
          onClick={e => e.stopPropagation()}
          data-testid="help-support-modal"
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                  <Question size={22} className="text-white" weight="fill" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">Need Help?</h2>
                  <p className="text-white/80 text-sm">We're here to support you</p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-white/20 rounded-lg transition-colors"
                data-testid="close-help-modal"
              >
                <X size={20} className="text-white" />
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 space-y-4">
            {/* Email Support */}
            <button
              onClick={handleEmailClick}
              data-testid="email-support-btn"
              className="w-full p-4 bg-slate-800/50 hover:bg-slate-800 border border-slate-700 rounded-xl transition-all group flex items-center gap-4"
            >
              <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                <Envelope size={24} className="text-blue-400" weight="fill" />
              </div>
              <div className="flex-1 text-left">
                <h3 className="text-white font-medium">Email Support</h3>
                <p className="text-slate-400 text-sm">{supportEmail}</p>
              </div>
              <ArrowRight size={20} className="text-slate-500 group-hover:text-white group-hover:translate-x-1 transition-all" />
            </button>

            {/* FAQ / Help Center */}
            <div className="p-4 bg-slate-800/30 border border-slate-700/50 rounded-xl">
              <div className="flex items-start gap-3">
                <ChatCircle size={20} className="text-purple-400 flex-shrink-0 mt-0.5" />
                <div>
                  <h4 className="text-white font-medium text-sm">Quick Tips</h4>
                  <ul className="text-slate-400 text-sm mt-2 space-y-1.5">
                    <li>• Complete the Business Builder first for best results</li>
                    <li>• Use "Run My Week" for daily action items</li>
                    <li>• Check My Creations for all saved assets</li>
                    <li>• Upgrade to Pro for full business packages</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Response time note */}
            <p className="text-center text-slate-500 text-xs">
              We typically respond within 24 hours on business days
            </p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default HelpSupportModal;
